<template>
  <div class="soar-container">
    <div class="flex-1 flex flex-col gap-y-3 my-6">
      <div class="flex-1 flex flex-col gap-y-3 my-3">
        <h2 class="text-2xl pb-4 border-b border-brand-grayblue-300 text-brand-black-secondary">
          {{ t9nLabel }}
        </h2>
        <p class="text-justify"></p>
      </div>
      <div class="flex w-full h-full items-center justify-center">
        <Form
          ref="form"
          :keep-values="true"
          class="md:w-1/2 xs:w-full flex flex-col"
          @submit="onSubmit"
        >
          <div class="my-2">
            <h2 class="text-2xl my-3 text-brand-black-secondary">{{ t9nHeading }}</h2>
          </div>
          <div class="w-full flex gap-4 flex-col my-4">
            <Field :rules="validateEmail" name="email" v-slot="{ field, errors: errs }">
              <SimpleTextInput
                :field="field"
                :errors="errs"
                :label="$t('email')"
                input-class="w-full"
                direction="flex-col"
              />
            </Field>
          </div>
          <div class="w-full flex justify-end">
            <FilledButton
              class="px-5 py-1.5 text-white"
              as="button"
              type="submit"
              :disabled="isActive"
            >
              {{ $t('continue') }}
            </FilledButton>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>

<script setup>
import FilledButton from '@/components/Buttons/Filled.vue'
import { Field, Form } from 'vee-validate'
import SimpleTextInput from '@/components/SimpleForm/TextInput.vue'
import { computed, ref } from 'vue'
import validateApi from '@/services/validate'
import { useI18n } from 'vue-i18n'
import axiosInstance from '@/services'
import { notify } from 'notiwind'

const i18n = useI18n()

const props = defineProps({
  label: {
    type: String,
    default: ''
  },
  heading: {
    type: String,
    default: ''
  },
  registrationType: {
    type: Boolean,
    required: true
  }
})

const form = ref()
const isActive = ref(false)

const t9nLabel = computed(() => i18n.t(props.label || ''))
const t9nHeading = computed(() => i18n.t(props.heading || ''))

async function validateEmail(value) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (!emailRegex.test(value)) {
    return i18n.t('INVALID_EMAIL')
  }
  isActive.value = true
  try {
    const response = await validateApi.validateUserName(value)
    if (response && response !== null) {
      return i18n.t('EMAIL_ALREADY_USED')
    }
    isActive.value = false
    return true
  } catch (error) {
    isActive.value = false
    console.error('Error checking email:', error)
    return i18n.t('INVALID_EMAIL')
  }
}

const onSubmit = async (value) => {
  isActive.value = true
  if (!value.email) return
  try {
    const result = await axiosInstance.post(
      `/api/user/username/${props.registrationType}/email`,
      value.email,
      {
        headers: {
          'Content-Type': 'text/plain'
        }
      }
    )
    if (result.data && Object.keys(result.data).includes('errorMessage')) {
      notify(
        {
          group: 'error',
          title: i18n.t('NoRecordFound')
        },
        6000
      )
    }
    form.value.resetForm()
  } catch (error) {
    console.error('Error during API call:', error)
  }
  isActive.value = false
}
</script>
